module.exports = __webpack_public_path__ + "assets/5be0f929a55ba031b2b2d1c288c25050.svg";